module.exports = __webpack_public_path__ + "static/media/email-solid.ea19e958.svg";